import { SettoreVO } from "./settoreVO";

export class DatiDecretoManualiVO {
  numero: string;
  data: string;
  anno: string;
  oggetto: string;
  segnatura: string;
  struttura: SettoreVO; // usate nella form
  dataConclusione: string;
}
